import Framework from 'framework';

export default {
	get(key) {
		var localData = null;
		try{
			localData = Framework.global.localStorage.getItem(key);
			if(localData != null) {
				localData = JSON.parse(localData);
			}
		} catch(localStorageError) {
			console.log(localStorageError);
		}
		return localData;
	},
	set(key, localData) {
		var dataToSet;
		try{
			dataToSet = JSON.stringify(localData);
			Framework.global.localStorage.setItem(key, dataToSet);
		} catch(error) {
			console.log(error);
		}
	},
	remove(key) {
		try{
			Framework.global.localStorage.removeItem(key);
			if(Framework.global.localStorage.getItem(key)){
				Framework.global.localStorage.setItem(key, '');
			}
		} catch(error) {
			console.log(error);
		}
	}
};
